// Provenance of a clinical task. Values must match exactly what the backend stores in the
// `task_source` field on `clinical_tasks` documents. Mirrors the backend ClinicalTaskSource enum.
export enum ClinicalTaskSource {
  MANUAL = 'manual',
  MONTHLY_JOURNEY = 'monthly_journey',
  HOSP_ED_OUTREACH = 'hosp_ed_outreach',
}
